"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _slugify = _interopRequireDefault(require("slugify"));

var _Link = _interopRequireDefault(require("../../components/Link"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Nav = (0, _styled["default"])('nav')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    display: 'none',
    position: 'relative'
  }, theme.media.laptop, {
    display: 'block'
  });
});
var Ul = (0, _styled["default"])('ul')({
  height: '80px'
});
var Li = (0, _styled["default"])('li')({
  "float": 'left',
  display: 'table',
  height: '100%',
  marginLeft: '20px',
  marginRight: '20px',
  marginBottom: '0px',
  '&:first-of-type': {
    marginLeft: 0
  },
  '&:last-of-type': {
    marginRight: 0
  }
});
var InnerLink = (0, _styled["default"])(_Link["default"])(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'table-cell',
    verticalAlign: 'middle',
    fontWeight: 600,
    letterSpacing: '0.2px',
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textTransform: 'uppercase',
    fontSize: 14,
    color: theme.colors.text,
    textDecoration: 'none'
  };
});
var Stroke = (0, _styled["default"])('div')(function (_ref4) {
  var hasStroke = _ref4.hasStroke,
      _ref4$strokeLeft = _ref4.strokeLeft,
      strokeLeft = _ref4$strokeLeft === void 0 ? 0 : _ref4$strokeLeft,
      _ref4$_strokeWidth = _ref4._strokeWidth,
      _strokeWidth = _ref4$_strokeWidth === void 0 ? 0 : _ref4$_strokeWidth,
      theme = _ref4.theme;

  var secondary = theme.colors.secondary;
  return {
    position: 'absolute',
    backgroundColor: secondary,
    height: hasStroke ? '4px' : '0px',
    left: "".concat(strokeLeft, "px"),
    width: "".concat(_strokeWidth, "px"),
    bottom: 0,
    transition: 'left 0.2s cubic-bezier(0.165, 0.84, 0.44, 1), width 0.1s, height 0.1s'
  };
});

var DesktopMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(DesktopMenu, _Component);

  function DesktopMenu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DesktopMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DesktopMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasStroke: false,
      _strokeWidth: 0,
      strokeLeft: 0
    });

    return _this;
  }

  _createClass(DesktopMenu, [{
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      this.setState({
        hasStroke: true,
        strokeLeft: e.currentTarget.offsetLeft,
        _strokeWidth: e.currentTarget.offsetWidth
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        hasStroke: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          hasStroke = _this$state.hasStroke,
          strokeLeft = _this$state.strokeLeft,
          _strokeWidth = _this$state._strokeWidth;
      return _react["default"].createElement(Nav, null, _react["default"].createElement(Ul, {
        onMouseLeave: this.onMouseLeave.bind(this)
      }, this.props.links.map(function (link, i) {
        return _react["default"].createElement(Li, {
          key: i,
          onMouseEnter: _this2.onMouseEnter.bind(_this2)
        }, _react["default"].createElement(InnerLink, {
          href: link.url,
          tracker: 'menu-'.concat((0, _slugify["default"])(link.label).toLocaleLowerCase())
        }, link.label));
      })), _react["default"].createElement(Stroke, {
        hasStroke: hasStroke,
        strokeLeft: strokeLeft,
        _strokeWidth: _strokeWidth
      }));
    }
  }]);

  return DesktopMenu;
}(_react.Component);

DesktopMenu.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string
  }))
};
var _default = DesktopMenu;
exports["default"] = _default;